var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('KSRMechanik',{key:_vm.service_reload,attrs:{"kit":_vm.kit,"storeId":_vm.studioId,"guestbooking":"true"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }